import propsTypes from "prop-types";
import Switch from "@material-ui/core/Switch";

const Primary = ({ name, checked, onChnage }) => {
  const handleChange = (event) => {
    onChnage(name, event.target.checked);
  };

  return (
    <Switch
      checked={checked}
      color="primary"
      name={name}
      inputProps={{ "aria-label": "primary checkbox" }}
      onChange={handleChange}
    />
  );
};

Primary.propsTypes = {
  name: propsTypes.string,
  checked: propsTypes.bool,
  onChnage: propsTypes.func,
};

Primary.defaultProps = {
  checked: false,
};

export default Primary;
